export default __webpack_public_path__ + "static/amenagement-balcon-dimensions-5e7cc02e7e5e55de78ac82d96a3eadcc.png";